import React, { Component } from 'react';
import AfspHeader from 'components/AfspHeader';
import AfspFooter from 'components/AfspFooter';
import { pra, praTitle } from 'utils/legal';
import { Layout, List } from  'antd';

const { Header, Content, Footer } = Layout;

export default class PASLayout extends Component {
    render() {
        const
        { win, state } = this.props,
        { height, width } = win,
        { setData } = this.props.services;

        var headerConfig = {
            state: {
                login: state.app.login,
                request: state.app.request
            },
            service: setData,
            win: win,
            config: {
                title: 'afsp-home',
                type: 'home'
            }
        }

        return (
            <div>
                <Layout>
                    <Header style={{ zIndex: 1, height: '114px' }}>
                        <AfspHeader {...headerConfig} />
                    </Header>
                    <Content style={{
                        zIndex: 0,
                        overflow: 'auto',
                        position: 'fixed',
                        top: '118px',
                        bottom: '106px',
                        left: '12px',
                        right: '12px'
                    }}>
                        <div>
                            <div className='afsp-home-pra-title'>
                                {praTitle}
                            </div>
                            <List
                                itemLayout="horizontal"
                                dataSource={pra}
                                renderItem={item => (
                                    <List.Item>
                                        <div className='afsp-home-pra-content' dangerouslySetInnerHTML={{__html: item.content}}>
                                        </div>
                                    </List.Item>
                                )}
                            >
                            </List>
                        </div>
                    </Content>
                    <AfspFooter win={win} />
                </Layout>
            </div>
        )
    }
}
//
